import React, { useState, useEffect } from "react"
import { Form as AntForm } from "antd"
import PropTypes from "prop-types"
import { useOutletContext } from "react-router-dom"

import { ROLES } from "@components/Domain/Constants"
import hasAccess from "@api/hasAccess"
import { UpdateModal } from "@components/Page"
import { useOnSubmit } from "@modules/backstage/users"
import { getFormSchema } from "@components/Form"
import { useAppContext } from "@components/AppContext"

import getUpdateInputs from "./helpers/getUpdateInputs"

const readOperation = "backstage/ReadUser"
const updateMemberOperation = "backstage/UpdateMember"
const updateFundMemberOperation = "backstage/UpdateFundMember"

const LABEL_STAFF = "Staff"
const LABEL_ADMINISTRATOR = "Administrator"
const LABEL_TITLE = `Edit [ENTITY]`
const LABEL_SUBMIT = "Save"

const getUpdateSchema = getFormSchema(updateMemberOperation)


const UpdateMemberModal = ({ modal }) => {
  const [ currentUser, setCurrentUser ] = useState({})
  const [ schema, setSchema ] = useState([])

  const [ form ] = AntForm.useForm()

  const { identity, isConsoleOrganization } = useAppContext()
  const { updateUser } = useOutletContext()

  const { id: userId, roles = [] } = currentUser

  const { organization } = identity
  const { name: organizationName, controllerId } = organization

  const isLiaison = roles.includes(ROLES.BROKER)
  const isAccountant = roles.includes(ROLES.ACCOUNTANT)
  const isController = userId === controllerId

  const onSubmit = useOnSubmit(roles)

  const onSuccess = user =>
    updateUser(user)

  const onItemRead = user =>
    setCurrentUser(user)

  const updateSchema = () => {
    const { roles: formRoles = [] } = form.getFieldsValue()
    const isAdministrator = formRoles.includes(ROLES.ADMIN)
    const isApprover = roles.includes(ROLES.APPROVER)
    const shouldShowAccountantPermission = isApprover || isAdministrator

    let inputs = getUpdateInputs(isConsoleOrganization, updateSchema, organizationName, isLiaison, isController)

    if (!shouldShowAccountantPermission) {
      inputs = inputs.filter(input => input.name !== "_isAccountant")
    }

    const newSchema = getUpdateSchema(inputs)
    setSchema(newSchema)
  }

  const setAdditionalPermissions = () => {
    form.setFieldValue("_isLiaison", isLiaison)
    form.setFieldValue("_isAccountant", isAccountant)
  }

  useEffect(() => {
    updateSchema()
  }, [ currentUser ])

  useEffect(() => {
    setAdditionalPermissions()
  }, [ schema ])

  const isFund = hasAccess(["fund-users-write"])

  const updateOperation = isFund
    ? updateFundMemberOperation
    : updateMemberOperation

  const entity = isConsoleOrganization
    ? LABEL_ADMINISTRATOR
    : LABEL_STAFF

  const title = LABEL_TITLE
    .replace('[ENTITY]', entity)

  const updateModalProps = {
    operation: updateOperation,
    submitLabel: LABEL_SUBMIT,
    form,
    modal,
    title,
    entity,
    schema,
    onSubmit,
    onSuccess,
    onItemRead,
    readOperation,
  }

  return (
    <UpdateModal {...updateModalProps} />
  )
}

UpdateMemberModal.propTypes = {
  modal: PropTypes.shape({}).isRequired,
}

export default UpdateMemberModal
